/* eslint-disable react/no-unknown-property */
import { Component, Host, Listen, Prop, h, Element, State } from '@stencil/core';

@Component({
  tag: 'omk-label',
  styleUrl: 'omk-label.scss',
  shadow: true,
})
export class OmkLabel {
  /** The value of the for attribute must be a single id for a labelable form-related element in the same document as the <label> element. So, any given label element can be associated with only one form control. */
  @Prop() for: string;
  /** Places the label before the form related component if the component is encapsulated by the label. By default, the label comes after it's related component. */
  @Prop() labelBefore: boolean = false;
  /** User-visible sublabel text. Displays below the label with less emphasis. */
  @Prop() sublabel: string;
  /** Validation message for the form related component. */
  @Prop() validationMessage: string;
  /** Disables interaction and greys out the label. */
  @Prop() disabled: boolean = false;
  /** Controls whether the validation error component of the label is shown or not.  */
  @Prop() hideValidationMessage: boolean = false;
  @Element() el: HTMLElement;
  @State() labelPresent: boolean = false;

  @Listen('click')
  handleClick(event) {
    // handle only programmatic clicks and clicks on external labels
    // internal checkbox and label clicks are handled by the Material element
    // ignore links
    if (event.target.classList?.contains('omk-inline-link')) return;

    const slottedComponent = this.el.querySelector('[slot="component"]');
    const clickComesFromLabel =
      (event.composedPath()[1] as HTMLElement).classList?.contains('label-text') ||
      (event.composedPath()[2] as HTMLElement).classList?.contains('label-text');
    const forComponent = document.querySelector(`#${this.for}`);

    if (clickComesFromLabel && (slottedComponent || forComponent)) {
      if (slottedComponent) (slottedComponent as HTMLElement).click();
      if (forComponent) (forComponent as HTMLElement).click();
    }
  }

  slotHasChanged() {
    const slotted = this.el.shadowRoot.querySelector('label div slot') as HTMLSlotElement;
    this.labelPresent = !!slotted;
  }

  render() {
    return (
      <Host disabled={this.disabled}>
        <label
          htmlFor={this.for}
          style={{ order: this.labelBefore ? '-1' : '1' }}
          class={{ hide: !(this.labelPresent || this.validationMessage) }}
        >
          <div class="label-text">
            <slot onSlotchange={() => this.slotHasChanged()}></slot>
          </div>
          {this.sublabel && <div class="sublabel">{this.sublabel}</div>}
          <omk-validation-error
            validationMessage={this.validationMessage}
            hide={this.hideValidationMessage}
          ></omk-validation-error>
        </label>
        <slot slot="component" name="component"></slot>
      </Host>
    );
  }
}
